import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=e4d22cc2&scoped=true&"
import script from "./Query.vue?vue&type=script&lang=tsx&"
export * from "./Query.vue?vue&type=script&lang=tsx&"
import style0 from "./Query.vue?vue&type=style&index=0&id=e4d22cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d22cc2",
  null
  
)

export default component.exports